export const Permission = {
    PERMISSION_MERCHANT_USE_PAYMENT_LINK: 'PERMISSION_MERCHANT_USE_PAYMENT_LINK',
    PERMISSION_MERCHANT_CREATE_DISPOSABLE_PAYMENT_LINK: 'PERMISSION_MERCHANT_CREATE_DISPOSABLE_PAYMENT_LINK',
    PERMISSION_MERCHANT_MANAGE_REFUNDS: 'PERMISSION_MERCHANT_MANAGE_REFUNDS',
    PERMISSION_MERCHANT_MANAGE_BUSINESS: 'PERMISSION_MERCHANT_MANAGE_BUSINESS',
    PERMISSION_MERCHANT_CREATE_BUSINESS_PAYMENT_LINK: 'PERMISSION_MERCHANT_CREATE_BUSINESS_PAYMENT_LINK',
    PERMISSION_MERCHANT_VIEW_PAYMENTS: 'PERMISSION_MERCHANT_VIEW_PAYMENTS',
    PERMISSION_MERCHANT_WITHDRAW_FUNDS: 'PERMISSION_MERCHANT_WITHDRAW_FUNDS',
    PERMISSION_DEVELOPER_WITHDRAW_FUNDS: 'PERMISSION_DEVELOPER_WITHDRAW_FUNDS',
    PERMISSION_DEVELOPER_VIEW_PAYMENTS: 'PERMISSION_DEVELOPER_VIEW_PAYMENTS',
    PERMISSION_DEVELOPER_MANAGE_TRANSACTIONS: 'PERMISSION_DEVELOPER_MANAGE_TRANSACTIONS',
    PERMISSION_DEVELOPER_MANAGE_REFUNDS: 'PERMISSION_DEVELOPER_MANAGE_REFUNDS',
    PERMISSION_DEVELOPER_MANAGE_BUSINESS: 'PERMISSION_DEVELOPER_MANAGE_BUSINESS',
    PERMISSION_DEVELOPER_CREATE_PAYMENT_LINK: 'PERMISSION_DEVELOPER_CREATE_PAYMENT_LINK',
    PERMISSION_DEVELOPER_USE_PAYMENT_LINK: 'PERMISSION_DEVELOPER_USE_PAYMENT_LINK'
}